export const wifiActions = ['GetWifiStatus', 'GetSavedWifiNetworks', 'ConnectWifi', 'DisconnectWifi']

export function companyWifiForm (config) {
  const encryption = String(config.encryption || '').replace(/[^a-z0-9]/gi, '').toUpperCase()
  const aliases = {
    OPEN: 'OPEN',
NONE: 'OPEN',
NOPASS: 'OPEN',
    WPA: 'WPA2',
WPA2: 'WPA2',
WPAPSK: 'WPA2',
WPA2PSK: 'WPA2',
    WPAWPA2: 'WPA2',
WPAWPA2PSK: 'WPA2',
WPA2PERSONAL: 'WPA2',
    WPA2PERSONALPSK: 'WPA2',
    WPAPERSONAL: 'WPA2',
    WPAWPA2PERSONAL: 'WPA2',
    WPA2WPA3: 'WPA2',
WPA2WPA3PSK: 'WPA2',
WPA2WPA3PERSONAL: 'WPA2',
    WPA3: 'WPA3',
WPA3PSK: 'WPA3',
WPA3PERSONAL: 'WPA3',
    WPA3PERSONALSAE: 'WPA3',
SAE: 'WPA3',
  }
  // Unknown/enterprise modes still load the credentials, but require an explicit
  // security choice instead of silently substituting a different protocol.
  const security = aliases[encryption] || (encryption ? null : config.password ? 'WPA2' : 'OPEN')
  return {
    ssid: config.essid || '',
    password: security === 'OPEN' ? '' : config.password || '',
    security,
    useSavedNetwork: false,
    networkId: null,
    hidden: false,
  }
}

export const wifiSecurityOptions = [
  { text: 'Open / None (no password)', value: 'OPEN' },
  { text: 'WPA / WPA2-Personal / PSK', value: 'WPA2' },
  { text: 'WPA3-Personal / SAE', value: 'WPA3' },
  { text: 'WEP (use a saved profile)', value: 'WEP', disabled: true },
  { text: 'Enterprise / EAP / PEAP / TLS / TTLS (use a saved profile)', value: 'EAP', disabled: true },
  { text: 'Enhanced Open / OWE (use a saved profile)', value: 'OWE', disabled: true },
]

// Stored reports use Newtonsoft's PascalCase; tolerate camelCase wire reports too.
export function parseWifiReport (value) {
  try {
    const report = typeof value === 'string' ? JSON.parse(value) : value
    if (!report || typeof report !== 'object') return null
    const field = (object, name) => object[name] !== undefined ? object[name] : object[name[0].toUpperCase() + name.slice(1)]
    const status = field(report, 'status')
    const networks = field(report, 'savedNetworks')
    return {
      success: field(report, 'success'),
      code: field(report, 'code'),
      status: status && typeof status === 'object' ? {
        wifiEnabled: field(status, 'wifiEnabled'),
        connected: field(status, 'connected'),
        ssid: field(status, 'ssid'),
        ipAddress: field(status, 'ipAddress'),
        validatedInternet: field(status, 'validatedInternet'),
      } : null,
      savedNetworks: Array.isArray(networks) ? networks.map(network => ({
        ssid: field(network, 'ssid'),
        networkId: field(network, 'networkId'),
        security: field(network, 'security'),
      })) : null,
    }
  } catch (_) {
    return null
  }
}

export function validateWifiConnect (form, isGroup = false) {
  const errors = []
  const bytes = new TextEncoder().encode(form.ssid || '').length
  if (!bytes || bytes > 32 || (form.ssid || '').includes('\0')) errors.push('SSID must contain 1 to 32 UTF-8 bytes and no null characters.')
  if (!['OPEN', 'WPA2', 'WPA3'].includes(form.security)) errors.push('Select OPEN, WPA2 or WPA3 security.')
  if (!Number.isInteger(Number(form.timeoutSeconds)) || form.timeoutSeconds < 5 || form.timeoutSeconds > 120) errors.push('Connection timeout must be 5 to 120 seconds.')
  if (!form.useSavedNetwork && form.security !== 'OPEN') {
    const password = form.password || ''
    if (!/^[\x20-\x7E]{8,63}$/.test(password) && !(form.security === 'WPA2' && /^[a-fA-F0-9]{64}$/.test(password))) errors.push('Enter an 8 to 63 character ASCII passphrase, or a 64 digit hexadecimal WPA2 PSK.')
  }
  if (form.networkId !== null && form.networkId !== undefined && form.networkId !== '') {
    if (isGroup || !form.useSavedNetwork || !Number.isInteger(Number(form.networkId)) || Number(form.networkId) < 0) errors.push('A network ID must be a non-negative integer for a saved network on one device.')
  }
  return errors
}

export function wifiConnectPayload (form, ttlMinutes, isGroup = false) {
  const payload = { ssid: form.ssid, useSavedNetwork: form.useSavedNetwork, timeoutSeconds: Number(form.timeoutSeconds), ttlMinutes: Number(ttlMinutes) }
  if (!form.useSavedNetwork) {
    payload.security = form.security
    payload.hidden = form.hidden
    if (form.security !== 'OPEN') payload.password = form.password
  } else if (!isGroup && form.networkId !== null && form.networkId !== undefined && form.networkId !== '') {
    payload.networkId = Number(form.networkId)
  }
  return payload
}

// A group's owner does not establish the company of its effective members.
export function singleDeviceCompanyId (devices = []) {
  if (!devices.length || devices.some(device => !device.companyId)) return null
  const ids = [...new Set(devices.map(device => String(device.companyId)))]
  return ids.length === 1 ? devices[0].companyId : null
}
